var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgBell(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 27,
    viewBox: "0 0 24 27",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.515 21.5V22.5C15.515 23.5609 15.0935 24.5783 14.3434 25.3284C13.5932 26.0786 12.5758 26.5 11.515 26.5C10.4541 26.5 9.43668 26.0786 8.68653 25.3284C7.93638 24.5783 7.51496 23.5609 7.51496 22.5V21.5M22.245 19.4644C20.64 17.5 19.5068 16.5 19.5068 11.0844C19.5068 6.125 16.9743 4.35812 14.89 3.5C14.6131 3.38625 14.3525 3.125 14.2681 2.84062C13.9025 1.59625 12.8775 0.5 11.515 0.5C10.1525 0.5 9.12683 1.59688 8.76496 2.84188C8.68058 3.12938 8.41996 3.38625 8.14308 3.5C6.05621 4.35938 3.52621 6.12 3.52621 11.0844C3.52308 16.5 2.38996 17.5 0.784957 19.4644C0.119957 20.2781 0.702457 21.5 1.86558 21.5H21.1706C22.3275 21.5 22.9062 20.2744 22.245 19.4644Z",
    stroke: "black",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBell);
export default __webpack_public_path__ + "static/media/bell.31c8d78529923a6a2eed2488433a07d6.svg";
export { ForwardRef as ReactComponent };